import React from "react";
import PropTypes from "prop-types";
import { compose, withHandlers, setDisplayName } from "recompose";
import { endImpersonateEmployeeSession } from "actions/loginActions";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { RouteMap } from "components/common/navigation/routeMap";
import IconWarning from "assets/images/icon/icon-warning.svg";

const enhanceHRImpersonateMessageCard = compose(
  withHandlers({
    endImpersonateEmployeeHandler: props => () => {
      endImpersonateEmployeeSession();
      // eslint-disable-next-line xss/no-location-href-assign
      location.href = RouteMap.HR_Impersonate;
    },
  }),
  setDisplayName("HRImpersonateMessageCard")
);

const HRImpersonateMessageCard = ({
  hrAdmin,
  employee,
  redirect,
  endImpersonateEmployeeHandler,
}) =>
  <div className="apl-notification apl-notification--wrapper apl-notification__info">
    <div className="apl-notification__message apl-notification__message--column">
      <IconWarning height="24" />
      <strong>
        <FormattedMessage
          {...messages.hrImpersonateUserMessage}
          values={{ hrAdminFullname: employee.fullName }}
        />
      </strong>
    </div>
    <div className="apl-notification__message apl-notification__message--column">
      <a className="apl-close" onClick={endImpersonateEmployeeHandler}>
        <FormattedMessage {...messages.hrEndImpersonateUserMessage} />
      </a>
    </div>
  </div>;

HRImpersonateMessageCard.propTypes = {
  hrAdmin: PropTypes.object,
  employee: PropTypes.object,
  redirect: PropTypes.func,
  endImpersonateEmployeeHandler: PropTypes.func,
};

export default enhanceHRImpersonateMessageCard(HRImpersonateMessageCard);



// WEBPACK FOOTER //
// ./components/hrAdmin/HRImpersonateMessageCard.js